import { Component, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ElementRef, ViewChild, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { CohortsService } from '../../services/cohorts/cohorts.service';
@Component({
  selector: 'app-cohorts',
  standalone: false,
  templateUrl: './cohorts.component.html',
  styleUrls: ['./cohorts.component.scss'],
})
export class CohortsComponent implements OnInit {
  spinner: boolean = false;
  searchValue: string = '';
  page: number = 1;
  page_size: number = 20;
  totalRecords: number = 0;
  config: any;
  filterPage: string = 'COHORTS';
  pageTitle: string = 'المجموعات';
  filterData: any;
  filterDataInit: any = {};
  filterParamsUrl: Record<string, string | string[]> = {};
  cohorts: any[] = [];
  currentItemsPerPage: number = 0;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private matDialog = inject(MatDialog);
  private cohortService = inject(CohortsService);
  private titleService = inject(Title);
  private filter = inject(FiltersService);

  @ViewChild('goUp', { static: true }) contentPage!: ElementRef;
  confirmationDialogRef: MatDialogRef<ConfirmationBoxComponent> | null = null;

  ngOnInit(): void {
    this.config = {
      id: 'cohortPagination',
      itemsPerPage: this.page_size,
      currentPage: this.page,
      totalItems: this.totalRecords,
    };

    this.titleService.setTitle(this.pageTitle + ' | عاين');
    this.getFiltersData();

    this.route.queryParams.subscribe((params) => {
      if (params['page'] && params['page_size']) {
        this.page = Number(params['page']);
        this.page_size = Number(params['page_size']);

        const { page, page_size, ...restparams } = params;
        this.filterParamsUrl = { ...restparams };
        this.filterDataInit = { ...restparams };

        this.getCohorts();
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }
    });
  }

  getFiltersData(): void {
    const params = {
      filter_page: this.filterPage
    };

    this.filter.getFiltersData(params).subscribe({
      next: (data) => {
        this.filterData = data;
      }
    });
  }

  getCohorts(): void {
    this.cohortService.getCohorts({ page: this.page, page_size: this.page_size, query: this.searchValue, ...this.filterParamsUrl }).subscribe(
      (response: any) => {
        this.cohorts = response.data;
        this.config['totalItems'] = response.meta?.pagination?.count || 0;
        this.spinner = false;
      }
    );
  }

  filterFormValues(event: any): void {
    this.filterParamsUrl = event.filterParamsUrl;
    this.spinner = true;
    this.page = 1;
    this.config = {
      ...this.config,
      currentPage: 1
    };
    this.router.navigate([], {
      queryParams: { page: 1, page_size: this.page_size, ...this.filterParamsUrl },
      queryParamsHandling: '',
    });
  }

  quickSearch(searchValue: string): void {
    this.searchValue = searchValue;
    this.page = 1;
    this.config = {
      ...this.config,
      currentPage: 1
    };
    this.router.navigate([], {
      queryParams: { page: 1, query: searchValue || null },
      queryParamsHandling: 'merge',
    });
  }

  isActiveValueChanged(event: any, cohortId: number, index: number): void {
    if (!event.value) return;

    // Check if there's currently an active cohort (other than the one being activated)
    const hasActiveOther = this.cohorts.some(cohort => cohort.id !== cohortId && cohort.is_active);

    // Temporarily update the data model to match the UI change
    this.cohorts = this.cohorts.map(cohort => ({
      ...cohort,
      is_active: cohort.id === cohortId ? true : cohort.is_active
    }));

    if (hasActiveOther) {
      // Show confirmation dialog only if another cohort is currently active
      this.showActivationConfirmationBox(cohortId);
    } else {
      // No other cohort is active, activate directly without confirmation
      this.activateCohort(cohortId);
    }
  }

  addCohort(): void {
    this.router.navigate(['/pages/ask-ayen/cohorts/add']);
  }

  goToDetails(cohortId: number): void {
    this.router.navigate(['/pages/ask-ayen/cohorts', cohortId]);
  }

  pageChanged(event: any): void {
    this.page = event;
    this.config = {
      ...this.config,
      currentPage: event
    };
    this.router.navigate([], {
      queryParams: { page: event },
      queryParamsHandling: 'merge',
    });
    this.contentPage?.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  pageSizeChanged(event: any): void {
    this.page_size = event;
    this.page = 1;
    this.config = {
      ...this.config,
      itemsPerPage: event,
      currentPage: 1
    };
    this.router.navigate([], {
      queryParams: { page: 1, page_size: event },
      queryParamsHandling: 'merge',
    });
  }

  activateCohort(cohortId: number): void {
    this.cohortService.updateCohort(cohortId, { is_active: true }, '').subscribe(
      (response: any) => {
        this.cohorts = this.cohorts.map(cohort => ({
          ...cohort,
          is_active: cohort.id === cohortId
        }));
      },
      (error: any) => {
        this.cohorts = this.cohorts.map(cohort => ({
          ...cohort,
          is_active: cohort.id === cohortId ? false : cohort.is_active
        }));
      }
    );
  }

  showActivationConfirmationBox(cohortID: number): void {
    this.confirmationDialogRef = this.matDialog.open(ConfirmationBoxComponent, {
      data: {
        id: cohortID,
        isDelete: false,
        confirmBtn: 'تأكيد',
        title: 'تفعيل مجموعة',
        message: 'تأكيد تفعيل هذه المجموعة يلغي تفعيل المجموعة المفعّلة حالياً.',
      },
    });
    this.confirmationDialogRef?.afterClosed().subscribe((result) => {
      if (result) {
        this.activateCohort(result.id);
      } else {
        // User cancelled - reset the is_active value to false by creating completely new array and objects
        this.cohorts = this.cohorts.map(cohort => ({
          ...cohort,
          is_active: cohort.id === cohortID ? false : cohort.is_active
        }));
      }
    });
  }
}
